module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_7005.96097bfa.png";